import { defineStore } from 'pinia';
import { documentDetailApiService } from 'src/services';
import type { dynamicObj } from 'src/pages/assets';
import { i18n } from 'src/boot/i18n';

export const useLangOriginDropdownStore = defineStore(
  'language_origin_dropdown',
  {
    state: () => ({
      language_origins: [] as any,
      format_origins: [] as any,
      language_origins_loading: false,
      language_origins_loaded: false,
    }),
    actions: {
      async getLanguageIfEmpty() {
        if (this.language_origins.length > 0 || this.language_origins_loading) {
          return;
        }
        await this.getLanguageOptions();
      },
      async getLanguageOptions() {
        try {
          this.language_origins_loading = true;
          this.language_origins = [];
          this.format_origins = [];
          const response =
            await documentDetailApiService.getLanguageOriginList();

          if (!response) {
            throw response;
          }

          this.language_origins.push(
            Object.assign(
              {},
              {
                value: '',
                label: i18n.t('amount_date_format_select'),
              },
            ),
          );

          for (const [key, option] of Object.entries(response)) {
            const item = option as dynamicObj;
            const description = !item.description ? '' : item.description;
            this.language_origins.push(
              Object.assign(
                {},
                {
                  value: item.value,
                  label: item.label,
                  locale: item.locale,
                  description: description.replaceAll('\\n', '<br />'),
                },
              ),
            );

            this.format_origins.push(
              Object.assign(
                {},
                {
                  value: item.locale,
                  label: item.label,
                  description: description.replaceAll('\\n', '<br />'),
                },
              ),
            );
          }
        } catch (err) {
          logError(err);
        } finally {
          this.language_origins_loaded = true;
          this.language_origins_loading = false;
        }
      },
    },
  },
);
